import barba from '@barba/core';
import once from './barba-once';
import leave from './barba-leave';
import enter from './barba-enter';
import after from './barba-after';
import afterL from './barba-afterleave';

export default function () {
    // barba.init({
    //     debug: false,
    //     timeout: 6000,
    //     sync: true,
    //     //prefetchIgnore: false,
    //     transitions: [{
    //         name: 'default-transition',
    //         once() {
    //             once();
    //         },
    //         leave(data) {
    //             // PERMET DE RENDRE LA TRANSITION ASYNCHRONE CHARGEMENT PENDANT QUE LA TRANSITION SE FAIT
    //             const done = this.async();

    //             let href = data.next.url.href
    //             if (!href.includes('wp-admin')) {
    //                 leave(data, done);
    //             } else {
    //                 window.location.href = href
    //             }
    //         },
    //         afterLeave() {
    //             afterL();

    //         },
    //         enter(data) {
    //             enter(data);
    //         },
    //         after() {

    //             after();
    //         }
    //     }],


    // });
    // gtag('config', GTAG_ID, {
    //     send_page_view: false,
    // });
    // barba.hooks.after(() => {
    //     gtag('event', 'page_view', {
    //         'page_title': document.title,
    //         'page_location': location.href,
    //         'page_path': location.pathname,
    //     });
    // });
}
